import { useState, useCallback } from "react";
import { getUser, saveUser } from "@/store";
import Header from "@/components/Header";
import Toast from "@/components/Toast";
import Onboarding from "@/views/Onboarding";
import Checkin from "@/views/Checkin";
import History from "@/views/History";
import Settings from "@/views/Settings";

export default function HyphaApp() {
  const [view, setView] = useState("checkin");
  const [onboard, setOnboard] = useState(() => !getUser().onboardingDone);
  const [toast, setToast] = useState("");

  const showToast = useCallback((msg) => {
    setToast(msg);
    setTimeout(() => setToast(""), 2800);
  }, []);

  function handleOnboardComplete(userData) {
    saveUser({ ...userData, onboardingDone: true });
    setOnboard(false);
  }

  if (onboard) {
    return (
      <>
        <Onboarding onComplete={handleOnboardComplete} />
        <Toast message={toast} />
      </>
    );
  }

  return (
    <div className="hypha-app-shell" style={{
      display: "flex",
      flexDirection: "column",
      background: "var(--deep)",
      paddingTop: "var(--safe-top)",
      paddingBottom: "var(--safe-bot)",
    }}>
      <Header view={view} setView={setView} />
      <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
        {view === "checkin" && <Checkin showToast={showToast} />}
        {view === "history" && <History showToast={showToast} />}
        {view === "settings" && <Settings showToast={showToast} />}
      </div>
      <Toast message={toast} />
    </div>
  );
}
